export default __webpack_public_path__ + "static/media/38.5a378ab2.png";